<template>
	<div>
	<ul class="apply ovw soak soak_1 info">
		<li class="pad">
			<span>卡号</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" v-model="gift.cardID" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad" v-if="status > 1">
			<span>发货状态</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="status == 2 ? '待发货' : '已发货'" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>类别名称</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" v-model="giftProduct.sname" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad" style="border-bottom:0">
			<span>截止日期</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="gift.endDate.split('T')[0]" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
	</ul>
	<div style="height:10px;"></div>
	<ul class="apply ovw soak soak_1 info" v-if="status == 1">
		<li class="pad" v-if="status == 1" style="border-bottom:0">
			<span>清单</span>
		</li>
	</ul>
	<ul class="record_list2" v-if="status == 1">
		<li>
			<div>
				<div class="product-item" v-for="(item2,index2) in giftProduct.detail" :key="index2"><img :src="'/userfile/default/picture/' + item2.productID_simage" /><span>{{item2.productID_sname}}</span><h3>{{item2.num}}{{item2.productID_unit}}</h3></div>
			</div>
		</li>
	</ul>
	<ul class="apply ovw soak soak_1 info" v-if="status == 1">
		<li class="pad">
			<span>收货人</span>
			<div class="fr">
				<input placeholder="请输入收货人" autocomplete="off" class="font_c ipt" type="text" v-model="order.linkMan">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>手机号</span>
			<div class="fr">
				<input placeholder="请输入手机号" autocomplete="off" class="font_c ipt" type="text" v-model="order.mobile" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>选择收货区域</span>
			<div class="fr">
				<input placeholder="请选择收货区域" @click="showArea" id="Area" autocomplete="off" class="font_c ipt" type="text" v-model="order.area" name="mobile" />
				<input type="hidden" name="province" id="province" />
				<input type="hidden" name="city"  id="city" />
				<input type="hidden" name="county" id="county" />
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>详细地址</span>
			<div class="fr">
				<input placeholder="请输入详细地址" autocomplete="off" class="font_c ipt" type="text" v-model="order.addressDetail" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>发货日期</span>
			<div class="fr">
				<select style="background:transparent" autocomplete="off" class="font_c ipt" type="text" v-model="order.deliveryDate" name="xingming">
					<option v-for="(item2,index2) in days" :key="index2" :value="item2">{{item2}}</option>
				</select>
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>备注</span>
			<div class="fr">
				<input placeholder="请输入备注" autocomplete="off" class="font_c ipt" type="text" v-model="order.deliveryNote" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad btn-group">
			<a href="javascript:;" @click="submitOrder" class="detail-btn">提交订单</a>
			<a href="javascript:;" @click="exitSys" class="detail-btn detail-btn-default">退出</a>
		</li>
	</ul>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1 && gift.deliveryNo">
		<li class="pad" style="border-bottom:0">
			<span>顺丰 {{gift.deliveryNo}} 快递追踪</span>
		</li>
	</ul>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1">
		<li class="pad" v-for="(item,index2) in express" :key="index2">
			<span style="min-width:120px">{{item.time}}</span>
			<div class="fr">
				<div style="text-align: left;margin-left: 20px;" readonly autocomplete="off" class="font_c ipt">{{item.content}}</div>
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
	</ul>
	<div style="height:10px;" v-if="status > 1"></div>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1 && gift.deliveryNo">
		<li class="pad" style="border-bottom:0">
			<span>收货人信息</span>
		</li>
	</ul>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1">
		<li class="pad">
			<span>收货人</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.linkMan">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>手机号</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.mobile" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>详细地址</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.address" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>发货日期</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" :value="gift.deliveryDate.split('T')[0]" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad" style="border-bottom:0">
			<span>备注</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.deliveryNote" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
	</ul>
	<div style="height:10px;" v-if="status > 1"></div>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1">
		<li class="pad" style="border-bottom:0">
			<span>清单</span>
		</li>
	</ul>
	<ul class="record_list2" v-if="status > 1" style="margin-bottom:0">
		<li>
			<div>
				<div class="product-item" v-for="(item2,index2) in gift.detail" :key="index2"><img :src="'/userfile/default/picture/' + item2.productID_simage" /><span>{{item2.productID_sname}}</span><h3>{{item2.num}}{{item2.productID_unit}}</h3></div>
			</div>
		</li>
	</ul>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1">
		<li class="pad">
			<a href="javascript:;" @click="exitSys" class="detail-btn">退出</a>
		</li>
	</ul>

		<div id="addressSelectWrapper" v-if="isShowAddr">
			<div id="addressSelect">
				<div class="tip">
					<h3>所在地区</h3>
				</div>
				<div id="address">
					<div class="address-content">
						<ul id="province"><li @click="provinceClick(item2)" :class="provinceId.value == item2.value ? 'active' : ''" v-for="(item2,index2) in province" :key="index2">{{item2.name}}</li></ul>
						<ul id="city"><li @click="cityClick(item2)" :class="cityId.value == item2.value ? 'active' : ''" v-for="(item2,index2) in city" :key="index2">{{item2.name}}</li></ul>
						<ul id="area"><li @click="countyClick(item2)" :class="countyId.value == item2.value ? 'active' : ''" v-for="(item2,index2) in county" :key="index2">{{item2.name}}</li></ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import querystring from 'querystring';
import {
  City,
  GiftOrder_Current,
  GiftOrder_Order
} from "@/api/api.js"
export default {
  data () {
    return {
	  status:0,
	  isShowAddr:false,
	  days:[],
	  province:[],
	  city:[],
	  county:[],
	  provinceId:{value:''},
	  cityId:{value:''},
	  countyId:{value:''},
      model:{orderNo:'',createTime:'',status:0},
	  express:[],
	  giftProduct:{detail:[],sname:''},
	  gift:{CardID:'',endDate:'',detail:[],deliveryNo:''},
	  order:{token: "", linkMan: "", mobile: "",area:"",addressDetail:'', address: "", deliveryNote: "", deliveryDate: "" }
    }
  },
  methods:{
	  dateFormatter(d,fmt){
			var o = {
			"M+": d.getMonth() + 1, //月份 
			"d+": d.getDate(), //日 
			"h+": d.getHours(), //小时 
			"m+": d.getMinutes(), //分 
			"s+": d.getSeconds(), //秒 
			"q+": Math.floor((d.getMonth() + 3) / 3), //季度
		};
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	  },
	  dateAdd:function (d,interval, number) {
			var d = d;
			var k = { 'y': 'FullYear', 'q': 'Month', 'm': 'Month', 'w': 'Date', 'd': 'Date', 'h': 'Hours', 'n': 'Minutes', 's': 'Seconds', 'ms': 'MilliSeconds' };
			var n = { 'q': 3, 'w': 7 };
			eval('d.set' + k[interval] + '(d.get' + k[interval] + '()+' + ((n[interval] || 1) * number) + ')');
			return d;
		},
	  getDays(){
		  var d = new Date();
		  d = this.dateAdd(d,'d',1);
		  var days = [];
		  if(d.getHours() > 16){
			d = this.dateAdd(d,'d',1);
		  }
		  for(let i = 0; i < 10;i++){
			  days.push(this.dateFormatter(d,'yyyy-MM-dd'));
			  d = this.dateAdd(d,'d',1);
		  }
		  this.days = days;
	  },
	  showArea:function(){
		  this.isShowAddr  =true;
	  },
	  provinceClick:function(i){

		  let that = this;
		that.provinceId = i;
		City({ID:i.value},function(res){
		  	that.city = res.data;
		  	that.county = [];
	  	})
	  },
	  cityClick:function(i){
		  let that = this;
		that.cityId = i;
		City({ID:i.value},function(res){
		  	that.county = res.data;
	  	})
	  },
	  showTextData:function(){
		  let that = this;
		that.$message.success('订单提交成功！');
	  },
	  countyClick:function(i){
		  let that = this;
		that.countyId = i;
		  this.isShowAddr  =false;
that.order.area = that.provinceId.name + ' ' + that.cityId.name + ' ' + that.countyId.name;
	  },
	  submitOrder:function(){
		  let that = this;
		  if(!that.order.linkMan){
			that.$message.error('请输入收货人');
			return;
		  }
		  if(!that.order.mobile){
			that.$message.error('请输入手机号');
			return;
		  }
		  if(!that.order.area){
			that.$message.error('请选择收货区域');
			return;
		  }
		  if(!that.order.addressDetail){
			that.$message.error('请输入详细地址');
			return;
		  }
		  if(!that.order.deliveryDate){
			that.$message.error('请选择发货日期');
			return;
		  }
		  that.order.token = localStorage.getItem("giftsession");
		  that.order.address = that.order.area + ' ' + that.order.addressDetail;
		  GiftOrder_Order(that.order,function(res){
			  if(res.code == 200){
				that.$message.success('订单提交成功！');
				localStorage.removeItem("giftsession");
				that.$router.push('giftlogin');
			  }
			else
				that.$message.error(res.error);
			that.loadData();
		  })
	  },
	  exitSys:function(){
		let that = this;
		this.$confirm({
			title: '退出',
			okText: '确认退出',
			okType: 'danger',
			cancelText: '取消',
			content: h => <div style="color:red;">是否确认退出系统？</div>,
			onOk() {
				localStorage.removeItem("giftsession")
				that.$router.push('giftlogin');
			},
			onCancel() {
				console.log('Cancel');
			},
			class: 'test',
		});
	  },
	  loadData(){
		let that = this;
		let token = localStorage.getItem("giftsession");
		if(token) {
			GiftOrder_Current({ID:token},function(res){
				if(res.code != 200){
					that.$router.push('giftlogin');
					return;
				}
				that.gift = res.model;
				that.express = res.extand.Express;
				that.status = res.model.status;
				that.giftProduct = res.extand.GiftProduct;
			});
		}
	}
  },
  created:function(){
	  let that = this;
	  this.loadData();
	  this.getDays();
	  this.order.deliveryDate = this.days[0];
	  City({ID:0},function(res){
		  that.province = res.data;
	  })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record_list2{
  margin-bottom: 0;
  margin-top:0;
}
.detail-btn{
	background-color: #b28b5f;
	border: 1px solid #b28b5f;
    color: #fff;
    padding: 0.01rem;
    border-radius: 3px;
	display: block;
	width:100%;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/wechat/giftinfo.vue